export const SET_USER = 'SET_USER';
export const set_user = value => ({ type: SET_USER, value});